import { createGlobalStyle } from 'styled-components';

// Font declarations
export const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'SF Pro Rounded';
    src: url('/assets/fonts/SF-Pro-Rounded-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'SF Pro Rounded';
    src: url('/assets/fonts/SF-Pro-Rounded-Bold.otf') format('opentype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'SF Pro Rounded';
    src: url('/assets/fonts/SF-Pro-Rounded-Semibold.otf') format('opentype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'SF Pro Rounded';
    src: url('/assets/fonts/SF-Pro-Rounded-Thin.otf') format('opentype');
    font-weight: 100;
    font-style: normal;
  }
`;

// Convert pixels to rem (similar to mobile's rem function)
export const rem = (size) => `${size / 16}rem`;

// Single theme configuration
const theme = {
  colors: {
    primary: '#3d9970',
    secondary: '#ff851b',
    red: '#d32f2f',
    accent: '#000000',
    background: '#ffffff',
    text: {
      primary: '#3b3b3b',
      secondary: '#757575',
      disabled: '#9e9e9e',
      inverse: '#ffffff',
    },
    border: '#e0e0e0',
    error: '#d32f2f',
    success: '#4caf50',
    warning: '#ffeb3b',
  },
  spacing: {
    xs: rem(4),
    sm: rem(8),
    md: rem(16),
    lg: rem(24),
    xl: rem(32),
    xxl: rem(48),
  },
  typography: {
    fontFamily: "'SF Pro Rounded', sans-serif",
    fontSizes: {
      xs: rem(12),
      sm: rem(14),
      md: rem(16),
      lg: rem(18),
      xl: rem(20),
      xxl: rem(30),
      xxxl: rem(34),
    },
    fontWeights: {
      thin: 100,
      regular: 400,
      semibold: 600,
      bold: 700,
    },
  },
  borderRadius: {
    small: rem(4),
    medium: rem(8),
    large: rem(12),
    pill: rem(500),
  },
  shadows: {
    small: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    medium: '0 3px 6px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.12)',
    large: '0 10px 20px rgba(0,0,0,0.15), 0 3px 6px rgba(0,0,0,0.10)',
  },
};

// Export a function for compatibility, but it now ignores the mode parameter
export const createTheme = () => theme;

export default theme;
